<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="TXS"> </p>
<p class="FMEP">“Stories have to be told or they die, and when they die, we can’t remember who we are or why we’re here.”</p>
<p class="FMEPC">—Sue Monk Kidd, <span class="ePub-I">The Secret Life of Bees</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4ac7ed87